// src/components/PageManager.tsx

import React from 'react'
import LanguageSelector, { LanguageCode } from '../LanguageSelector'
import Xroad from '../Xroad'
import GoldenAccounts from '../GoldenAccounts'
import GoldenAccountsIntro from '../GoldenAccountsIntro'
import ContactForm from '../ContactForm'
import QAPage from '../QA'

interface PageManagerProps {
  selectedLanguage: string | null
  showXroad: boolean
  showAccounts: boolean
  showAccountsIntro: boolean
  showContactForm: boolean
  showQA: boolean
  contractType: string | null
  selectedAvatar: string | null
  sourcePath: string
  onSelectLanguage: (code: LanguageCode) => void
  onSelectPage: (page: number) => void
  onPlanSelect: (plan: string) => void
  onPlanIntroSelect: (plan: string) => void
  onShowFAQ: () => void
  onFormSubmit: () => void
  onQABack: () => void
}

export default function PageManager({
  selectedLanguage,
  showXroad,
  showAccounts,
  showAccountsIntro,
  showContactForm,
  showQA,
  contractType,
  selectedAvatar,
  sourcePath,
  onSelectLanguage,
  onSelectPage,
  onPlanSelect,
  onPlanIntroSelect,
  onShowFAQ,
  onFormSubmit,
  onQABack,
}: PageManagerProps) {
  // Language selector has priority - don't show other pages until language is selected
  if (selectedLanguage === null) {
    return <LanguageSelector onSelectLanguage={onSelectLanguage} />
  }

  return (
    <>
      {showXroad && <Xroad onSelectPage={onSelectPage} />}

      {showAccounts && <GoldenAccounts onSelectPlan={onPlanSelect} />}

      {showAccountsIntro && (
        <GoldenAccountsIntro onSelectPlan={onPlanIntroSelect} />
      )}

      {showContactForm && (
        <ContactForm
          contractVariant={contractType}
          onShowFAQ={onShowFAQ}
          onSubmit={onFormSubmit}
          selectedAvatar={selectedAvatar}
          sourcePath={sourcePath}
        />
      )}

      {showQA && <QAPage onBack={onQABack} />}
    </>
  )
}
